module.exports = __webpack_public_path__ + "img/vonestis_option_01.c0d4c427.jpg";